var _g, _circle, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBallBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 288,
    height: 300,
    viewBox: "0 0 288 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_514_11045)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 144,
    cy: 140,
    r: 120,
    fill: "url(#paint0_radial_514_11045)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144,
    cy: 140,
    r: 120,
    fill: "url(#paint1_radial_514_11045)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_514_11045",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 20,
    width: 240,
    height: 240
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 144,
    cy: 140,
    r: 120,
    fill: "url(#paint2_radial_514_11045)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_514_11045)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 144,
    cy: 140,
    r: 120,
    fill: "url(#paint3_radial_514_11045)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_514_11045)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.504 27.5078C85.2297 27.5078 31.5039 81.2336 31.5039 147.508C31.5039 178.722 43.4217 207.152 62.9551 228.497C39.0125 206.559 24.0002 175.032 24.0002 139.999C24.0002 73.7251 77.726 19.9993 144 19.9993C179.06 19.9993 210.609 35.035 232.549 59.0099C211.198 39.4462 182.745 27.5078 151.504 27.5078Z",
    fill: "url(#paint4_radial_514_11045)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_514_11045)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M263.071 125C255.69 184.195 205.194 230 144 230C82.8057 230 32.3099 184.195 24.9284 125C24.3157 129.914 24 134.92 24 140C24 206.274 77.7258 260 144 260C210.274 260 264 206.274 264 140C264 134.92 263.684 129.914 263.071 125Z",
    fill: "url(#paint5_radial_514_11045)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_514_11045)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 180.667,
    cy: 116.668,
    r: 43.3333,
    fill: "#41B6E6"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_514_11045)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 180.668,
    cy: 103.335,
    r: 30,
    fill: "#B5E9FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_514_11045",
    x: 0,
    y: 0,
    width: 288,
    height: 300,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 16
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0705882 0 0 0 0 0.0627451 0 0 0 0 0.0666667 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_514_11045"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.929412 0 0 0 0 0.976471 0 0 0 0 1 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_514_11045",
    result: "effect2_dropShadow_514_11045"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_514_11045",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_514_11045",
    x: 8,
    y: 3.99951,
    width: 240.549,
    height: 240.498,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "effect1_foregroundBlur_514_11045"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_514_11045",
    x: 8,
    y: 109,
    width: 272,
    height: 167,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "effect1_foregroundBlur_514_11045"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_514_11045",
    x: 113.334,
    y: 49.335,
    width: 134.666,
    height: 134.667,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    result: "effect1_foregroundBlur_514_11045"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_514_11045",
    x: 126.668,
    y: 49.335,
    width: 108,
    height: 108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    result: "effect1_foregroundBlur_514_11045"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_514_11045",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(189 110) rotate(63.435) scale(83.8525)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDEDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473958,
    stopColor: "#2B2A2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_514_11045",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(189 110) rotate(63.435) scale(83.8525)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDEDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473958,
    stopColor: "#57B5E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A8EC6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_514_11045",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(144 140) rotate(46.3972) scale(96.6666)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4DAFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934818,
    stopColor: "#127BAD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_514_11045",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(144 140) rotate(46.3972) scale(96.6666)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41B6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934818,
    stopColor: "#018AC1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_514_11045",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(144.004 139.993) rotate(-133.604) scale(96.6668 96.667)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#96E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934818,
    stopColor: "#41B6E6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_514_11045",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(144 140) rotate(46.3973) scale(96.6668 96.6668)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41B6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973958,
    stopColor: "#006F9C"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBallBlue);
export default __webpack_public_path__ + "static/media/ball_blue.6f633688ab6d5f009b354bd08cd68717.svg";
export { ForwardRef as ReactComponent };